/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsCategories
 */
export interface AssetsMelcoModelsCategories {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsCategories
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsCategories
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsCategories
     */
    category_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsCategories
     */
    asset_url?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsCategories
     */
    publish_state: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsCategories
     */
    created_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsCategories
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsCategories
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsCategories
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
}

export function AssetsMelcoModelsCategoriesFromJSON(json: any): AssetsMelcoModelsCategories {
    return AssetsMelcoModelsCategoriesFromJSONTyped(json, false);
}

export function AssetsMelcoModelsCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsCategories {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'category_type': !exists(json, 'category_type') ? undefined : json['category_type'],
        'asset_url': !exists(json, 'asset_url') ? undefined : json['asset_url'],
        'publish_state': json['publish_state'],
        'created_date': (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
    };
}

export function AssetsMelcoModelsCategoriesToJSON(value?: AssetsMelcoModelsCategories | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'category_type': value.category_type,
        'asset_url': value.asset_url,
        'publish_state': value.publish_state,
        'created_date': (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
    };
}


